import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Wallet from "./pages/Wallet";
import News from "./pages/News";
import Profile from "./pages/Profile";
import Faq from "./pages/Faq";
import Terms from "./pages/Rules";
import ShopPoints from "./pages/Shop";
import CheckProtect from "./pages/CheckProtect";
import SecretKey from "./pages/SecretKey";
import Loader from "./components/Loader";
import RequireAuth from "./components/RequireAuth";
import RequireFlow from "./components/RequireFlow";
import RequireGuest from "./components/RequireGuest";
import "./App.css";
// import "./css/style.css";
import "./css/skin-modes.css";
import "./css/bootstrap.min.css";
import "./css/custom.css";
import "./css/new.css";
import "./plugins/iconfonts/font-awesome/css/font-awesome.min.css";
import "./plugins/iconfonts/remixicon/remixicon.css";

function App() {
  return (
        <Router>
      <ToastContainer position="top-right" autoClose={4000} theme="colored" />
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/loader-test" element={<Loader />} />
        <Route path="/login" element={<RequireGuest><Login /></RequireGuest>} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/check-protect"
          element={
            <RequireFlow sessionKeys={["login_username", "login_password"]} redirectTo="/login">
              <CheckProtect />
            </RequireFlow>
          }
        />
        <Route path="/wallet" element={<RequireAuth><Wallet /></RequireAuth>} />
        <Route path="/news" element={<RequireAuth><News /></RequireAuth>} />
        <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
        <Route path="/faq" element={<RequireAuth><Faq /></RequireAuth>} />
        <Route path="/rules" element={<RequireAuth><Terms /></RequireAuth>} />
        <Route path="/shop" element={<RequireAuth><ShopPoints /></RequireAuth>} />
        <Route
          path="/protects"
          element={
            <RequireFlow sessionKeys={["register_username", "register_password"]} redirectTo="/register">
              <SecretKey />
            </RequireFlow>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;